import { render, staticRenderFns } from "./Planos.vue?vue&type=template&id=3f0b426d"
import script from "./Planos.vue?vue&type=script&lang=js"
export * from "./Planos.vue?vue&type=script&lang=js"
import style0 from "./Planos.vue?vue&type=style&index=0&id=3f0b426d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports